import { render, staticRenderFns } from "./telecomFraud.vue?vue&type=template&id=120bf9c7&scoped=true"
import script from "./telecomFraud.vue?vue&type=script&lang=js"
export * from "./telecomFraud.vue?vue&type=script&lang=js"
import style0 from "./telecomFraud.vue?vue&type=style&index=0&id=120bf9c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120bf9c7",
  null
  
)

export default component.exports